// These is the function that check the user is admin or not based on the token
import { jwtDecode } from "jwt-decode";
import { getLoginData } from "../AppStoreData";

export async function checkIfUserIsAdmin() {
  try {
    const data = await getLoginData();
    const { AccessToken } = data;

    const decodedToken = jwtDecode(AccessToken);

    const isAdmin =
      decodedToken["cognito:groups"] &&
      decodedToken["cognito:groups"].includes("admin");

    return isAdmin;
  } catch (error) {
    console.error("Error checking if user is admin:", error.message);
    return false;
  }
}
